module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEYAAABGCAYAAABxLuKEAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAC9SURBVHgB7dyxDYNAEADBf8s1uDc3QTE0QW80AQXASsRoJr5odcFFN/f/cgwuPoNbwgRhgjBBmCBMECYIE4QJ36eDv22d4wWeXvo2JggThAnCBGGCMEGYIEwQJggThAnCBGGCMEGYIEwQJggThAnCBGGCMEGYIEwQJggThAnCBGGCMEGYIEwQJggThAnCBGGCMEGYIEwQJggThAnCBGGCMEGYIEwQJky/He7ZmCBMECYIE4QJwgRhgjBBmHAChC4J7UjYWG4AAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/stickers/ui/screens/new-sticker-media-audio/img/stop.png
// module id = 1342
// module chunks = 0